<template>
  <!-- Mobile Event Details Section -->
  <div class="lg:hidden mb-2 mt-2 px-4 sm:px-6">
    <button
      type="button"
      class="bg-surface-canvas border border-border-level-300 cursor-pointer dark:bg-surface-clear dark:border-border-level-600 dark:hover:bg-surface-level-800 flex hover:bg-surface-level-50 items-center justify-between px-4 py-2 rounded-xl transition-colors w-full"
      @click="handleOpen"
    >
      <div class="flex flex-col space-y-1">
        <!-- Event Details Label -->
        <div
          class="dark:text-content-level-400 font-medium text-content-level-500 text-left text-sm tracking-wide"
        >
          {{ $t('commerce.mobileEventDetailsButton.eventDetails') }}
        </div>

        <!-- Event Address -->
        <div
          v-if="streetAddress"
          class="flex items-center space-x-2"
        >
          <span class="dark:text-content-inverse font-medium text-content-level-900 text-xs">
            {{ streetAddress }}
          </span>
        </div>
      </div>

      <div class="flex items-center text-sm">
        {{ $t('commerce.mobileEventDetailsButton.edit')
        }}<ChevronRightIcon class="h-4 ml-2 text-content-level-400 w-4" />
      </div>
    </button>
  </div>
</template>

<script setup lang="ts">
import { ChevronRightIcon } from '@heroicons/vue/24/outline'
import { useSearchStore } from '~/stores/useSearchStore'

// Define emits
const emit = defineEmits<{ open: [] }>()

const handleOpen = () => {
  emit('open')
}

// Get search store
const searchStore = useSearchStore()

// Computed property for street address
function getStreetAddress(searchQuery: unknown): string {
  if (searchQuery === null || searchQuery === undefined) return ''

  const firstPartOrFallback = (value: string): string => {
    const firstPart = value.split(',')[0]?.trim()
    return firstPart !== undefined && firstPart.length > 0 ? firstPart : value
  }

  // Handle different query structures
  if (typeof searchQuery === 'string') {
    // Extract just the street address (first part before comma)
    return firstPartOrFallback(searchQuery)
  }

  if (typeof searchQuery === 'object') {
    const query = searchQuery
    if ('q' in query && typeof query.q === 'string') {
      // Extract just the street address (first part before comma)
      return firstPartOrFallback(query.q)
    } else if ('address' in query && typeof query.address === 'string') {
      // Extract just the street address (first part before comma)
      return firstPartOrFallback(query.address)
    }
  }

  return ''
}

// Computed property for street address
const streetAddress = computed(() => getStreetAddress(searchStore.searchQuery))
</script>
